import { LoaderService } from './../loader/loader.service';
import { Component, OnInit } from '@angular/core';
import { ChildNotesService } from './child-notes.service';
import { ToastService } from '../_services/toast-service';
import { Subscription } from 'rxjs';
import { Note } from './note.type';
import { Student } from '../student-list/student';
import { JwtHelperService } from '@auth0/angular-jwt';
import { StudentService } from '../_services/student.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'child-notes',
	styleUrls: ['./child-notes.component.css'],
	templateUrl: './child-notes.component.html',
})
export class ChildNotesComponent implements OnInit {
	notes: Note[] = [];
	n: Note;
	inValidNote: boolean = false;
	isSubmitting: boolean = false;
	activeStudent: Student;
	decoded: any;
	formAction: string;
	subscriptions: Subscription[] = [];
	constructor(
		public notesService: ChildNotesService,
		public toastService: ToastService,
		private studentService: StudentService,
		private jwtHelper: JwtHelperService,
		private modalService: NgbModal,
		public LoaderService: LoaderService,
	) {}

	ngOnInit(): void {
		const token = localStorage.getItem('currentUser');
		this.decoded = this.jwtHelper.decodeToken(token);
		this.subscriptions.push(
			this.studentService.selectedStudent$.subscribe((studentData: Student) => {
				this.LoaderService.setLoadingNotes(true);
				this.activeStudent = studentData;
				this.notesService.notes(this.activeStudent.childId).subscribe((data: []) => {
					this.notes = data['notes'];
					this.LoaderService.setLoadingNotes(false);
				});
			}),
		);
	}

	public showWindow(type, n, m) {
		this.modalService.open(m);
		this.inValidNote = false;
		this.formAction = type;
		this.isSubmitting = false;
		this.n = n;
	}

	public editNote(n: Note, value, m) {
		if (value.length >= 4) {
			this.isSubmitting = true;
			var index = this.notes.findIndex((x) => x.id == n.id);
			this.notes[index].note = value;
			this.subscriptions.push(
				this.notesService.updateNote(n).subscribe(() => {
					this.toastService.showSuccess('Successfully Updated');
					this.modalService.dismissAll(m);
				}),
			);
		} else {
			this.inValidNote = true;
		}
	}
	public addNote(value, m) {
		if (value.length >= 4) {
			this.isSubmitting = true;
			let newNote = {
				childId: this.activeStudent.childId,
				note: value,
				createdByUserId: this.decoded.id,
			};
			this.subscriptions.push(
				this.notesService.addNote(newNote).subscribe((data) => {
					this.notes.unshift(data.result);
					this.modalService.dismissAll(m);
				}),
			);
		} else {
			this.inValidNote = true;
		}
	}

	public removeNote(n: Note) {
		this.notes.splice(
			this.notes.findIndex((item) => item.id === n.id),
			1,
		);
		this.subscriptions.push(
			this.notesService.deleteNote(n.id).subscribe(() => {
				this.toastService.showSuccess('Successfully Deleted');
			}),
		);
	}
}
